import React from 'react';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import { Link } from 'react-router-dom';
export default props => {
  return (
    <div>
      {props.link !== undefined ? (
        <Link
          to={
            props.billToType === 'lender'
              ? `/lenders/${props.id}`
              : `/escrow-companies/${props.id}`
          }
        >
          {props.billToType === 'lender' ? 'Lender' : 'Escrow'} - {props.name}
          {props.contact_name !== null && props.contact_name.length > 0
            ? ` - ${props.contact_name}`
            : ''}
        </Link>
      ) : (
        <React.Fragment>
          {props.billToType === 'lender' ? 'Lender' : 'Escrow'} - props.name
        </React.Fragment>
      )}
      <br />
      {props.address_line_1 !== null && props.address_line_1.length > 0 && (
        <React.Fragment>
          {props.address_line_1}
          {props.address_line_2 !== null && props.address_line_2.length > 0 && (
            <React.Fragment>,&nbsp;{props.address_line_2}</React.Fragment>
          )}
          <br />
        </React.Fragment>
      )}
      <AddressHelper {...props} address_line_1={null} address_line_2={null} />
      <br />
      {props.phone !== null && props.phone !== '' && (
        <div>Phone: {props.phone}</div>
      )}
      {props.fax !== null && props.fax !== '' && <div>Fax: {props.fax}</div>}
      {props.email !== null && props.email !== '' && (
        <div>Email: {props.email}</div>
      )}
    </div>
  );
};
